import { faWheelchair } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Message } from "semantic-ui-react";

export function ControlledRichTextEditorAltTextWarning() {
  return (
    <Message warning className='tw-flex tw-items-center tw-gap-3'>
      <div className='tw-text-warning-dark'>
        <FontAwesomeIcon icon={faWheelchair} className='tw-h-6 tw-w-6' />
      </div>
      <div>
        <Message.Header className='tw-text-base'>
          Not WCAG Compliant: Alt text is missing for one or more images
        </Message.Header>
        <Message.Content className='tw-flex tw-flex-col tw-justify-between tw-text-sm lg:tw-flex-row lg:tw-items-center'>
          Alt text describes images for blind and low-vision users.
        </Message.Content>
      </div>
    </Message>
  );
}
